export enum StorefrontWidgetImageElement {
  None = "none",
  CustomImage = "custom_image",
  Shield = "shield",
  Gift = "gift",
  Lock = "lock",
}
